import { ComponentChildren } from 'preact';
import { useDocumentTitle } from 'client/utils/use-document-title';
import { getBrand } from 'shared/campaign-brands';

type Props = {
  children: ComponentChildren;
  docTitle?: string[];
  brand?: string;
};

export function CampaignPageShell({ children, docTitle, brand }: Props) {
  useDocumentTitle(docTitle || []);

  const brandDef = getBrand(brand);
  const fontUrl = `https://fonts.googleapis.com/css2?${brandDef.fonts.map((f) => `family=${f}`).join('&')}&display=swap`;

  return (
    <div
      class="campaign-page"
      data-brand={brandDef.id}
      style={`min-height: 100vh; background: #fff; font-family: var(--m-font)`}
    >
      <link href={fontUrl} rel="stylesheet" />
      {children}
    </div>
  );
}

export const PageShell = CampaignPageShell;
